module.exports = __webpack_public_path__ + "img/Group296.c0b4bba7.png";